import { useTenantStore } from '../stores/tenant.store.js';
import type { MembershipProps } from '@dosfilos/domain';

// Returns the current user's membership for the active tenant
export function useCurrentMembership(): MembershipProps | null {
  return useTenantStore((s) => s.currentMembership);
}
